import { render, staticRenderFns } from "./CadTreino.vue?vue&type=template&id=d2f245be&"
import script from "./CadTreino.vue?vue&type=script&lang=js&"
export * from "./CadTreino.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports